var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "normal-page" }, [
        _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "v-height-flag" },
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", _vm._b({}, "el-col", _vm.gridl, false), [
                      _c(
                        "div",
                        { staticClass: "rank-left v-height-flag" },
                        [
                          _c(
                            "el-row",
                            { staticClass: "rank-left-header" },
                            [
                              _c("el-col", { attrs: { span: 18 } }, [
                                _c("div", { staticClass: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("hr.ranktypes"))),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "text-right",
                                  attrs: { span: 6 },
                                },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: "添加类别",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "iconfont icontianjia color-doc pointer",
                                        on: {
                                          click: function ($event) {
                                            return _vm.addRankType()
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "v-height-flag" }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  { name: "height", rawName: "v-height" },
                                ],
                              },
                              [
                                _c(
                                  "el-scrollbar",
                                  { staticStyle: { height: "100%" } },
                                  [
                                    _c(
                                      "ul",
                                      { staticClass: "rank-left-top" },
                                      _vm._l(
                                        _vm.rankData,
                                        function (item, index) {
                                          return _c(
                                            "li",
                                            {
                                              key: index,
                                              staticClass: "clearfix",
                                              class:
                                                _vm.rankIndex === index
                                                  ? "active"
                                                  : "",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleRankClick(
                                                    index,
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "pull-left" },
                                                [_vm._v(_vm._s(item.name))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "pull-right" },
                                                [
                                                  _c(
                                                    "el-popover",
                                                    {
                                                      ref: "pop-" + item.id,
                                                      refInFor: true,
                                                      attrs: {
                                                        placement: "bottom-end",
                                                        trigger: "click",
                                                        offset: 10,
                                                      },
                                                      on: {
                                                        "after-enter":
                                                          function ($event) {
                                                            return _vm.handleShow(
                                                              item.id
                                                            )
                                                          },
                                                        hide: _vm.handleHide,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "right-item-list",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "right-item",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.editRankType(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "public.edit"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "right-item",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.deleteRankType(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "public.delete"
                                                                    )
                                                                  ) +
                                                                  "\n                              "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("i", {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.rankIndex ===
                                                              index,
                                                            expression:
                                                              "rankIndex === index",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "icon iconfont icongengduo pointer rank-icon",
                                                        attrs: {
                                                          slot: "reference",
                                                        },
                                                        slot: "reference",
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("el-col", _vm._b({}, "el-col", _vm.gridr, false), [
                      _c(
                        "div",
                        { staticClass: "rank-right v-height-flag" },
                        [
                          _c("oaFromBox", {
                            attrs: {
                              dropdownList: _vm.dropdownList,
                              isViewSearch: false,
                              total: _vm.total,
                              title: "职级列表",
                              btnText: "添加职级",
                              isAddBtn: true,
                            },
                            on: {
                              addDataFn: _vm.addRank,
                              dropdownFn: _vm.batchHandleDelete,
                              confirmData: _vm.confirmData,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mt10 table-box" },
                            [
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.tableData,
                                    "row-key": "id",
                                    height: _vm.tableHeight,
                                    "default-expand-all": "",
                                    "tree-props": { children: "children" },
                                  },
                                  on: {
                                    "selection-change":
                                      _vm.handleSelectionChange,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { type: "selection", width: "55" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "name",
                                      label: _vm.$t("hr.rankname"),
                                      "min-width": "150",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "alias",
                                      label: _vm.$t("hr.ranktype"),
                                      "min-width": "100",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "info",
                                      label: "职级描述",
                                      "min-width": "200",
                                      "show-overflow-tooltip": "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "line1" },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.info || "--")
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "card.name",
                                      label: _vm.$t("hr.founder"),
                                      "min-width": "120",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "address",
                                      label: _vm.$t("public.operation"),
                                      width: "140",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "hasPermi",
                                                    rawName: "v-hasPermi",
                                                    value: [
                                                      "hr:enterprise:job:rankManagement:edit",
                                                    ],
                                                    expression:
                                                      "['hr:enterprise:job:rankManagement:edit']",
                                                  },
                                                ],
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.editRank(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("public.edit"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "hasPermi",
                                                    rawName: "v-hasPermi",
                                                    value: [
                                                      "hr:enterprise:job:rankManagement:delete",
                                                    ],
                                                    expression:
                                                      "['hr:enterprise:job:rankManagement:delete']",
                                                  },
                                                ],
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteRank(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("public.delete")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "page-fixed" },
                                [
                                  _c("el-pagination", {
                                    attrs: {
                                      "page-size": _vm.where.limit,
                                      "current-page": _vm.where.page,
                                      "page-sizes": [15, 20, 30],
                                      layout:
                                        "total,sizes, prev, pager, next, jumper",
                                      total: _vm.total,
                                    },
                                    on: {
                                      "size-change": _vm.handleSizeChange,
                                      "current-change": _vm.pageChange,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("dialog-form", {
              ref: "dialogForm",
              attrs: {
                "roles-config": _vm.rolesConfig,
                "form-data": _vm.formBoxConfig,
              },
              on: {
                isOk: function ($event) {
                  return _vm.getTableData()
                },
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }